import debounce from 'lodash/debounce';

class ExplainerBlock {
  constructor() {
    this.Explainerblocks = document.querySelectorAll('.explainer-block');
    this.initialize();
  }

  initialize() {
    this.Explainerblocks.forEach( ExplainerBlock => {
      let currentSlideNumber = 1;

      let slideCount = ExplainerBlock.querySelector('.explainer-block__slides');
      if (slideCount.childNodes.length <= 1) {
        return;
      }

      // Show controls only when there are multiple slides.
      ExplainerBlock.querySelector('.explainer-block__controls').classList.add('is-active');

      /**
      * Functionality to handle left nav button click
      */
      ExplainerBlock.querySelector('.contols-button .button-left').addEventListener('click', () => {
        let currentSlide = ExplainerBlock.getAttribute('data-currentSlide');
        const slidesContainer = ExplainerBlock.querySelector('.explainer-block__slides');
        if ( 0 !== Number( currentSlide ) ) {
          currentSlide--;
          currentSlideNumber = currentSlide + 1;
          addSlideTranslate(currentSlide, ExplainerBlock);
        }

        if (0 == currentSlide) {
          ExplainerBlock.querySelector('.contols-button .button-left').classList.add('disabled');
          ExplainerBlock.querySelector('.contols-button .button-right').classList.remove('disabled');
        } else {
          ExplainerBlock.querySelector('.contols-button .button-right').classList.remove('disabled');
        }
        if (currentSlideNumber > 0 ) {
          ExplainerBlock.querySelector('.block-control__current_number').textContent = currentSlideNumber;
        }
        ExplainerBlock.setAttribute('data-currentSlide', currentSlide );
      } );

      /**
      * Functionality to handle right nav button click
      */
      ExplainerBlock.querySelector('.contols-button .button-right').addEventListener('click', () => {
        let currentSlide = ExplainerBlock.getAttribute('data-currentSlide');
        const slidesContainer = ExplainerBlock.querySelector('.explainer-block__slides');

        if (currentSlide < slidesContainer.childNodes.length - 1) {
          currentSlide++;
          currentSlideNumber = currentSlide + 1;
          addSlideTranslate(currentSlide, ExplainerBlock);
        }

        if ((slidesContainer.childNodes.length - 1) == currentSlide) {
          ExplainerBlock.querySelector('.contols-button .button-right').classList.add('disabled');
          ExplainerBlock.querySelector('.contols-button .button-left').classList.remove('disabled');
        } else {
          ExplainerBlock.querySelector('.contols-button .button-left').classList.remove('disabled');
        }
        if (currentSlideNumber <= slidesContainer.childNodes.length) {
          ExplainerBlock.querySelector('.block-control__current_number').textContent = (currentSlideNumber);
        }
        ExplainerBlock.setAttribute('data-currentSlide', currentSlide );
      } );

      /**
       * Functionality to update navigation dots when mobile slider is used.
       */
      const mobileBreakPoint = 569;

      if ( mobileBreakPoint > window.innerWidth ) {
        ExplainerBlock.querySelector('.explainer-block__slides').addEventListener(
          'scroll',
          /**
           * Debouncing will help us mitigate unnecessary performance overhead.
           * This will group multiple scroll events generated by a single touch swipe in mobiles and will run the
           * function just once rather than processing every scroll event generated from that single swipe.
           */
          debounce( e => {
            const container = e.target;
            const scrollWidthMax =  container.scrollWidth -  container.clientWidth;
            /**
         * Current scrolled percent of the entire scrollable container for the related posts.
         */
            const scroll = ( container.scrollLeft / scrollWidthMax ) * 100;
            /**
         * Creating breakpoints based on the number of slides available.
         */
            const breakpoint = 100 / container.childNodes.length;

            /**
             * Setting up the active class on the navigation dots acording to breakpoint it lies in.
             */
            for (let i = 1; i < container.childNodes.length + 1; i++) {
              if (scroll <= breakpoint * i) {
                // setNavDot(i - 1, ExplainerBlock);
                return;
              }
            }
          }, 20),
          {
            passive: true,
          },
        );
      }
    } );

    /**
    * Function to set the nav dot active corresponding to the slide in view.
    */
    function setNavDot( currentSlide, ExplainerBlock ) {
      ExplainerBlock.querySelectorAll('.block-control__dot').forEach( navDot => {
        navDot.classList.remove('active');
      });

      ExplainerBlock.querySelector(`.block-control__dot:nth-of-type(${currentSlide + 1})`).classList.add( 'active');
    }

    /**
	 * Function to add translate on slides for slider.
	 */
    function addSlideTranslate(currentSlide, ExplainerBlock) {
      ExplainerBlock.querySelectorAll('.explainer-block__slide').forEach( slide => {
        slide.style.transform = `translateX(-${currentSlide * 100}%)`;
      });
      // setNavDot( currentSlide, ExplainerBlock );
      ExplainerBlock.querySelectorAll('.explainer-block__slide').forEach( slide => {
        slide.style.transform = `translateX(-${currentSlide * 100}%)`;
      });
      // setNavDot( currentSlide, ExplainerBlock );
    }
  }

}

export default ExplainerBlock;
